import React from 'react'

const SuccessOrder = () => {
  return(
    <div className="d-flex justify-content-center align-items-center">
      <p className='h2 text-danger'>Your order has been placed</p>
    </div>
  )
}

export default SuccessOrder
